export default __webpack_public_path__ + "static/css/rome.static.css";